import styled from "styled-components";
import { colors, fonts } from "../../../styles/variables";

export const ProgressContainer = styled.div`
  padding: 20px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const BarContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 200px;
  height: 16px;
`;

export const TotalStatusBar = styled.div`
  width: 200px;
  height: 16px;
  border-radius: 8px;
  background-color: ${colors.peach};
`;
export const CurrentProgressBar = styled.div<{
  ratio: number;
  percentage: string;
}>`
  display: flex;
  flex: ${(props) => props.ratio || 1};
  width: ${(props) => props.percentage || "100%"};
  min-height: 16px;
  max-height: 16px;
  border-radius: 8px;
  background-color: ${colors.coral};
  z-index: 1;
  margin-top: -16px;
`;

export const ProgressText = styled.label`
  font-family: ${fonts.fontBauMedium};
  font-size: 16px;
  text-align: center;
  margin-top: 15px;
`;
